/*
 * The english translations of all Comtasks as specified in the teamspace file
 */
export const COM_TASKS_EN = {
  dyn: {
    FORMAT: {
      EMAIL: 'Email',
      NEWSLETTER: 'Newsletter',
      BLOG: 'Blog',
      BLOGPOST: 'Blog Post',
      WHITEPAPER: 'White Paper',
      FACHARTIKEL: 'Journal Article',
      GASTBEITRAG: 'Guest post',
      KLIENTENZUSAMMENFASSUNG: 'Client Summary',
      PRESSRELEASE: 'Pressrelease',
      SOCIALMEDIA: 'Social Media',
      socialmedia: 'Social Media',
      EXTERNERNEWSLETTER: 'External Newsletter',
      INTERNERNEWSLETTER: 'Internal Newsletter',
      BRIEFING: 'Briefing',
      ARTICLE: 'Article',
      PODCAST: 'Podcast Script',
      PRODUCTDESCRIPTION: 'Product description',
      AVERYLONGNEWSLETTER: 'A very long Newsletter',
      SOCIALCAPTIONS: 'Social Media Captions',
      EmailNewsletter: 'Email Newsletter',
      CaseStudy: 'Case Study',
      HowtoGuide: 'How to guide',
      InfographicText: 'Infographic Text',
      VideoScript: 'Video Script',
      PodcastScript: 'Podcast Script',
      LandingPageCopy: 'Landing Page Copy',
      BulletPointSummary: 'Bullet Point Summary',
      Langartikel: 'Long Article',
      Kurzmeldung: 'Short Article',
      Listicle: 'Listicle',
      WikiPediaPage: 'Wikipedia Page',
      PressReleaseContent: 'Press Release',
      Advertorial: 'Advertorial',
      BlogPostContent: 'Blog Post',
      NewsletterExtern: 'External Newsletter',
      EMailContent: 'Email',
      NewsletterIntern: 'Internal Newsletter',
      QAInterview: 'Q&A Interview',
      ProductDescriptionContent: 'Product Description'
    }
  }
}
/*
 * Deutsche Übersetzung für die ComTasks aus dem teampsace file
 */
export const COM_TASKS_DE = {
  dyn: {
    FORMAT: {
      EMAIL: 'Email',
      NEWSLETTER: 'Newsletter',
      BLOG: 'Blog',
      BLOGPOST: 'Blog Post',
      WHITEPAPER: 'White Paper',
      FACHARTIKEL: 'Fachartikel',
      GASTBEITRAG: 'Gastbeitrag',
      KLIENTENZUSAMMENFASSUNG: 'Klienten Zusammenfassung',
      PRESSRELEASE: 'Pressetext',
      SOCIALMEDIA: 'Social Media',
      socialmedia: 'Social Media',
      EXTERNERNEWSLETTER: 'Externer Newsletter',
      INTERNERNEWSLETTER: 'Interner Newsletter',
      BRIEFING: 'Briefing',
      ARTICLE: 'Artikel',
      PODCAST: 'Podcast Skript',
      PRODUCTDESCRIPTION: 'Produktbeschreibung',
      AVERYLONGNEWSLETTER: 'Ein sehr langer Newsletter',
      SOCIALCAPTIONS: 'Social Media Texte',
      EmailNewsletter: 'E-Mail-Newsletter',
      CaseStudy: 'Case Study',
      HowtoGuide: 'How-to Guide',
      InfographicText: 'Infografik-Text',
      VideoScript: 'Video-Skript',
      PodcastScript: 'Podcast-Skript',
      LandingPageCopy: 'Landingpage-Text',
      BulletPointSummary: 'Stichpunkt-Zusammenfassung',
      Langartikel: 'Langartikel',
      Kurzmeldung: 'Kurzmeldung',
      Listicle: 'Listicle',
      WikiPediaPage: 'Wikipedia-Seite',
      PressReleaseContent: 'Pressemitteilung',
      Advertorial: 'Advertorial',
      BlogPostContent: 'Blog-Beitrag',
      NewsletterExtern: 'Externer Newsletter',
      EMailContent: 'E-Mail',
      NewsletterIntern: 'Interner Newsletter',
      QAInterview: 'Q&A-Interview',
      ProductDescriptionContent: 'Produktbeschreibung'
    }
  }
}
